export const KNOWLEDGE_SOURCE_TYPES = {
  POLICY: "POLICY",
  CONVERSATION: "CONVERSATION",
  GUIDE: "GUIDE",
};

export const KNOWLEDGE_STATUSES = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ARCHIVED: "ARCHIVED",
};

export const SOURCE_TYPE_OPTIONS = [
  { value: KNOWLEDGE_SOURCE_TYPES.POLICY, label: "Policy" },
  { value: KNOWLEDGE_SOURCE_TYPES.CONVERSATION, label: "Conversation" },
  { value: KNOWLEDGE_SOURCE_TYPES.GUIDE, label: "Guide" },
];

export const STATUS_OPTIONS = [
  { value: KNOWLEDGE_STATUSES.DRAFT, label: "Draft" },
  { value: KNOWLEDGE_STATUSES.ACTIVE, label: "Active" },
  { value: KNOWLEDGE_STATUSES.INACTIVE, label: "Inactive" },
  { value: KNOWLEDGE_STATUSES.ARCHIVED, label: "Archived" },
];

export const getSourceTypeLabel = (value) =>
  SOURCE_TYPE_OPTIONS.find((option) => option.value === value)?.label || value;

export const getStatusLabel = (value) =>
  STATUS_OPTIONS.find((option) => option.value === value)?.label || value;

export const getStatusClassName = (status) => {
  const map = {
    [KNOWLEDGE_STATUSES.DRAFT]: "draft",
    [KNOWLEDGE_STATUSES.ACTIVE]: "active",
    [KNOWLEDGE_STATUSES.INACTIVE]: "inactive",
    [KNOWLEDGE_STATUSES.ARCHIVED]: "archived",
  };

  return map[status] || "draft";
};
